module.exports = {
  ...require('./ilmater'),
  ...require('./ilneval'),
  ...require('./istishia'),
}
